import { SHELL_VERSION } from "@bestowinc/tinkertoy-shell-deps";

/** Shell semver attached to every performance metric. */
export function getPerformanceTelemetryShellVersion(): string {
  return SHELL_VERSION;
}

/** Runtime mode from the host-injected `globalThis.ENV.MODE`, when present. */
export function getPerformanceTelemetryEnvironment(): string {
  const env = Reflect.get(globalThis, "ENV");
  if (typeof env === "object" && env !== null) {
    const mode = Reflect.get(env, "MODE");
    if (typeof mode === "string" && mode.length > 0) {
      return mode;
    }
  }
  return "unknown";
}
